export const GlobalStockLogo = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="assets/stocks/global">
        <g id="Union">
          <path
            d="M23.7 8.25C23.1477 8.25 22.7 8.69771 22.7 9.25V21.5927C22.7 22.145 23.1477 22.5927 23.7 22.5927H25.6166C26.1689 22.5927 26.6166 22.145 26.6166 21.5927V9.25C26.6166 8.69772 26.1689 8.25 25.6166 8.25H23.7Z"
            fill="#31708F"
          />
          <path
            d="M16.0416 13.125C16.0416 12.5727 16.4893 12.125 17.0416 12.125H18.9583C19.5106 12.125 19.9583 12.5727 19.9583 13.125V24.5973C19.9583 25.1496 19.5106 25.5973 18.9583 25.5973H17.0416C16.4893 25.5973 16.0416 25.1496 16.0416 24.5973V13.125Z"
            fill="#31708F"
          />
          <path
            d="M9.3833 17C9.3833 16.4477 9.83102 16 10.3833 16H12.3C12.8523 16 13.3 16.4477 13.3 17V26.75C13.3 27.3023 12.8523 27.75 12.3 27.75H10.3833C9.83102 27.75 9.3833 27.3023 9.3833 26.75V17Z"
            fill="#31708F"
          />
        </g>
      </g>
    </svg>
  );
};
